import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {
    AbstractActionNoCacheService
} from '../../../../../core/service/v2/service/action/abstractActionNoCache.service';
import {EmailSendPayload} from './emailSend.payload';
import {WorkflowTaskRepository} from '../../../../../workflow/task/impl/service/ngrx/workflowTask.repository';
import {WorkflowTaskConverter} from '../../../../../workflow/task/api/model/common/converter/workflowTask.converter';

@Injectable()
export class EmailActionSendService extends AbstractActionNoCacheService<EmailSendPayload, any> {

    public constructor(httpClient: HttpClient,
                       private workflowTaskRepository: WorkflowTaskRepository,
                       private workflowTaskConverter: WorkflowTaskConverter) {
        super('communication/emails', 'send', httpClient);
    }

    protected onResponse(response: any, payload: EmailSendPayload) {
        this.workflowTaskRepository.created(response);
    }

    protected buildResponse(response: any): any {
        return this.workflowTaskConverter.convert(response);
    }
}
